import { useState } from 'react';
import { useMapInstance } from 'shared/map-exports';
import { useMapEvent } from 'features/mapping/hooks/useMapEvent';

const roundToDecimalPlaces = (value: number, decimalPlaces: number): number => {
  return Number(value.toFixed(decimalPlaces));
};

export const useMapZoomLevel = (): number | undefined => {
  const map = useMapInstance();
  const [zoom, setZoom] = useState<number | undefined>(() =>
    map?.getZoom() ? roundToDecimalPlaces(map.getZoom(), 2) : undefined,
  );

  useMapEvent(
    'zoomend',
    (event) => {
      setZoom(roundToDecimalPlaces(event.target.getZoom(), 2));
    },
    map,
    true,
  );

  return zoom;
};
